/**
 * Product Upgrades V2 JavaScript
 */

document.addEventListener('DOMContentLoaded', () => {
  const updateCardContent = (select) => {
    const selectedOption = select.options[select.selectedIndex];
    const card = select.closest('.product-upgrades-v2__item');
    if (!card || !selectedOption) return;

    const variantId = select.value;
    const price = selectedOption.dataset.price;
    const comparePrice = selectedOption.dataset.comparePrice;

    const pTitle = selectedOption.dataset.productTitle;
    const pDesc = selectedOption.dataset.productDesc;
    const pImg = selectedOption.dataset.productImage;

    const hiddenInput = card.querySelector('.product-upgrades-v2__item-id');
    if (hiddenInput) {
      hiddenInput.value = variantId;
      hiddenInput.dataset.upgradePrice = price;
      hiddenInput.dataset.upgradeComparePrice = (comparePrice && comparePrice > 0) ? comparePrice : price;
      hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (pImg) {
      const imgEl = card.querySelector('.product-upgrades-v2__image');
      const placeholder = card.querySelector('.product-upgrades-v2__image-placeholder');
      if (imgEl) {
        imgEl.removeAttribute('srcset');
        imgEl.src = pImg;
        imgEl.style.display = 'block';
        if (placeholder) placeholder.style.display = 'none';
      }
    }

    if (pTitle) {
      const titleEl = card.querySelector('.product-upgrades-v2__name');
      if (titleEl) titleEl.textContent = pTitle;
    }

    if (pDesc) {
      const descEl = card.querySelector('.product-upgrades-v2__desc');
      if (descEl) descEl.textContent = pDesc;
    }

    const priceCurrentEl = card.querySelector('.product-upgrades-v2__price-current');
    const priceCompareEl = card.querySelector('.product-upgrades-v2__price-compare');

    if (priceCurrentEl) {
      priceCurrentEl.textContent = `+$${(price / 100).toFixed(0)}`;
    }

    if (priceCompareEl) {
      if (comparePrice && parseInt(comparePrice) > parseInt(price)) {
        priceCompareEl.textContent = `+$${(comparePrice / 100).toFixed(0)}`;
        priceCompareEl.style.display = 'block';
      } else {
        priceCompareEl.style.display = 'none';
      }
    }
  };

  const initUpgradesV2 = () => {
    const containers = document.querySelectorAll('.product-upgrades-v2');

    containers.forEach(container => {
      const variantSelectors = container.querySelectorAll('.product-upgrades-v2__variant-select');

      variantSelectors.forEach(select => {
        if (select.classList.contains('multi-product-select')) {
          updateCardContent(select);
        }
        select.addEventListener('change', () => updateCardContent(select));
      });
    });
  };

  initUpgradesV2();

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initUpgradesV2);
  }
});
